import { useStaticQuery, graphql } from 'gatsby';

const useBfcmCalendarQuery = () => {
  const query = useStaticQuery(graphql`
  query WpBfcmCalendarQuery {
    allWpBfcmCalendar(sort: {templatesBfcmCalendar: {postDate: ASC}}) {
      nodes {
        title
        templatesBfcmCalendar {
          buttons {
            iconColor
            leftIcon {
              iconName
            }
            openInNewTab
            rightIcon {
              iconName
            }
            text
            url
          }
          description
          postDate
        }
      }
    }
  }
  `);

  return query;
};

export default useBfcmCalendarQuery;
